import viewTimesheetModal from './viewTimesheetModal.html';

class ViewTimesheetModalCtrl {
  constructor(
    Authentication,
    TimesheetsService,
    TimesheetsUtils,
    EventCollection,
    Utils,
    sdk,
    extendShiftModel,
    $uibModal,
    $scope
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      TimesheetsService,
      TimesheetsUtils,
      EventCollection,
      Utils,
      sdk,
      extendShiftModel,
      $uibModal,
      $scope,
    });
  }

  $onInit() {
    this.TIMESHEET_ENTRY_TYPES = this.sdk('constants').TIMESHEET_ENTRY_TYPES;
    const { MARK_APPROVED, MARK_PENDING } = this.TIMESHEET_ENTRY_TYPES;

    this.timesheetGroups = this.Utils.breakDownTimesheetsToGroups(this.event.timesheetEntries).map(
      (group) => ({
        timesheets: group.filter((e) => ![MARK_APPROVED, MARK_PENDING].includes(e.type)),
        allTimesheets: group,
      })
    );
    this.isBreakRelevant =
      Boolean(this.Authentication.user.orgSettings.shiftBreakType) && this.event.breakDuration;
  }

  async viewTimesheet() {
    this.modal.close();
    try {
      await this.TimesheetsService.viewTimesheet({ event: this.event, mode: 'history' });
    } catch {
      //
    }
  }

  async editTimesheet() {
    try {
      this.$scope.$broadcast('timeclock-map-close');
      const withTimesheets = this.extendShiftModel(
        await this.EventCollection.getEvent(this.event.id, { includeTimesheets: 'full' })
      );
      const updatedEventPromise = await this.$uibModal.open({
        template:
          '<edit-timesheets modal="modal" readonly="readonly" event="event" initial-mode="mode"></edit-timesheets>',
        size: '620',
        backdrop: 'static',
        controller($scope, $uibModalInstance) {
          'ngInject';

          $scope.modal = $uibModalInstance;
          $scope.event = withTimesheets;
          $scope.readonly = false;
          $scope.mode = 'edit';
        },
      }).result;

      this.modal.close(updatedEventPromise);
      const updatedEvent = await updatedEventPromise;

      this.Utils.clearObject(this.event);
      Object.assign(this.event, updatedEvent);
    } catch {
      //
    }
  }

  canEditTimesheet() {
    return this.event && this.TimesheetsUtils.canEditTimesheet(this.event);
  }
}

export default {
  bindings: {
    event: '<',
    modal: '<',
  },
  templateUrl: viewTimesheetModal,
  controllerAs: 'ctrl',
  controller: ViewTimesheetModalCtrl,
};
